<template>
  <div id="service-staff-setting" class="shadow-md rounded-item tip-setting">
      <vx-card>
         <div class="setting-card-hidden">
               <div class="setting-card-scroll">
                  <h4 class="text-2xl font-bold">Tip Setting</h4>
                  <div class="flex align-center">
                     <vs-switch v-model="tip_setting" class="my-6" @click.stop="updateStaffReceipt"/>
                     <span class="pl-5">Tip or no tip</span>
                  </div>
                  <div v-if="tip_setting">
                     <div class="flex align-left flex-col">
                        <span class="my-3">Setup to 4 default tips for a customer to choose from when signing 
                           on screen (in addition to options for custom and no tip).</span>
                        <span class="my-3">If you are setup to have customers sign on on the printed receipt, 
                           the calculated tip and total for these suggestions will appear at the bottom of the receipt.</span>
                        <div class="w-row my-6">
                           <ul class="centerx flex align-center">
                              <li @click="changeTypeToPercent">
                                 <vs-radio v-model="tip_setting_type" vs-value="percent" class="flex align-center mr-6">%</vs-radio>
                              </li>
                              <li @click="changeTypeToUSD" class="mr-base">
                                 <vs-radio v-model="tip_setting_type" vs-value="usd" class="flex align-center ml-6">$</vs-radio>
                              </li>
                           </ul>
                        </div>
                        <vs-row class="flex align-center justify-between">
                           <label class="mt-5 mb-5 text-left bg-custom text-base font-semibold">Choose options</label>
                           <vs-button type="border" color="primary" @click="addModifier" style="min-width: 140px;">Create</vs-button>
                        </vs-row>
                        <vs-row class="border-custom border-r-0 border-l-0">
                           <vs-col vs-w="2" class="text-left p-5 bg-custom"></vs-col>
                           <vs-col vs-w="4" class="text-center p-5 bg-custom text-base font-semibold">Tip ({{tipType}})</vs-col>
                           <vs-col vs-w="4" class="text-center p-5 bg-custom text-base font-semibold">Tip suggestions</vs-col>
                           <vs-col vs-w="2" class="text-right p-5 bg-custom text-base font-semibold"></vs-col>
                        </vs-row>
                        <div class="modifier-table mb-6">
                           <vs-row class="border-custom border-r-0 border-l-0" v-for="(modifier, index) in tipSetting" :key="index">
                                 <vs-col vs-w="2" class="flex align-center text-center p-5">
                                    <vs-checkbox class="mx-0 text-sm" v-model="modifier.active"></vs-checkbox>
                                 </vs-col>
                                 <vs-col vs-w="4" class="text-center p-5">
                                    <vs-input type="number" v-validate="'required'" @change="handleFormatValue(modifier)" :max="maxValue" name="name" v-model="modifier.value" placeholder="-" class="input-value w-full" />
                                 </vs-col>
                                 <vs-col vs-w="4" class="text-center p-5">
                                    <vs-input v-validate="'required'" name="name" v-model="modifier.title" placeholder="-" class="input-value w-full" />
                                 </vs-col>
                                 <vs-col vs-w="2" class="text-center p-5 flex align-center justify-end">
                                    <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 stroke-current text-[#626262]" @click="removeModifier(modifier)" v-if="tipSetting.length > 1"/>
                                 </vs-col>
                           </vs-row>
                        </div>
                        <div class="flex justify-center my-3" slot="footer">
                           <vs-button type="filled" color="primary" @click="saveModifier" style="min-width: 140px;">Save</vs-button>
                        </div>
                     </div>
                  </div>
               </div>
         </div>
      </vx-card>
   </div>
</template>

<script>
export default {
   data() {
      return {
         tip_setting: false,
         isOpenLoading: false,
         tip_setting_type: '',
         tipSetting: [],
         tip_setting_status: 0,
         maxValue: 100,
         tipType: '',
         arrTipSetting: [],
      }
   },
   computed: {
      tipSettingActive(){
         return this.$store.state.appSetting.tipSetting.active
      }
   },
   created(){
      this.getTipSetting();
   },
   methods: {
      async getTipSetting(){
         this.openLoadingInDiv()
         await this.$store.dispatch("appSetting/GET_TIP").then(() => {
            let tipSettingModel = JSON.parse(JSON.stringify(this.$store.state.appSetting.tipSetting));
            this.tipSetting = JSON.parse(JSON.stringify(this.$store.state.appSetting.tipSetting.tip_items));
            this.tip_setting_type = this.$store.state.appSetting.tipSetting.type

            this.tip_setting = tipSettingModel.status;
            
            if(this.tip_setting_type == 'usd'){
               this.maxValue = 99999999;
               this.tipType = '$'
            }
            if(this.tip_setting_type == 'percent'){
               this.maxValue = 100;
               this.tipType = '%';
            }
         })
         this.closeLoading();
      },
      changeTypeToPercent(){
         this.tipType = '%';
      },
      changeTypeToUSD(){
         this.tipType = '$';
      },
      addModifier() {
         this.arrTipSetting = [...this.tipSetting];
         this.tipSetting.push({
            title: '',
            active: 0,
            value: '',
         })
         console.log(this.tipSetting);
      },
      removeModifier(modifier) {
         this.arrTipSetting = [...this.tipSetting];
         for (let i = 0; i < this.tipSetting.length; i++) {
            if (this.tipSetting[i].value == modifier.value) {
               this.tipSetting.splice(i, 1);
               return;
            }
         }
      },
      async saveModifier(){
         let tipList = [...this.tipSetting];
         for(let i = 0; i < tipList.length; i++){
            if(tipList[i].active == false){
               tipList[i].active = 0;
            }
            if(tipList[i].active == true){
               tipList[i].active = 1;
            }
            if(tipList[i].title == '' || tipList[i].value == '' ){
               this.$vs.dialog({
                  color: "danger",
                  title: "Notification",
                  text: "Tip items is empty",
                  acceptText: "OK",
               });
         this.closeLoading();
               return;
            }
            if(tipList[i].value > 100){
               if(this.tip_setting_type == 'percent'){
                  this.$vs.dialog({
                     color: "danger",
                     title: "Notification",
                     text: "Tip should less than 100 when type is percent",
                     acceptText: "OK",
                  });
         this.closeLoading();
                  return;
               }
            }
         }
         let obj = {
            value: {
               type: this.tip_setting_type,
               status: !this.tip_setting ? 1 : 0,
               tip_items: tipList,
            }
         }

         this.openLoadingInDiv()
         await this.$store.dispatch('appSetting/UPDATE_TIP', obj)
         .then(() => {
            this.$vs.notify({
                  title:'Notification',
                  text:'Update Tip Success',
                  color:'success',
                  position:'top-right'
               });
         })
         .catch(() => {
            this.$vs.notify({
                  title:'Notification',
                  text:'Update Tip Failed',
                  color:'danger',
                  position:'top-right'
               });
         })
         
         this.closeLoading();
      },
      updateStaffReceipt(){
         this.openLoadingInDiv();
         this.saveModifier();
         this.closeLoading();
      },
      handleFormatValue(value){
         if(value == ''){
            this.$vs.dialog({
              color: "danger",
              title: "Notification",
              text: "Tip just only number",
              acceptText: "OK",
            });
         }
      },
      openLoadingInDiv(){
         this.$vs.loading({
            container: '#app',
            scale: 0.8
         })
         if(this.loadTime){
            clearTimeout(this.loadTime);
            this.loadTime = null;
         }
         this.isOpenLoading = true;
         this.loadTime = setTimeout( ()=> {
            if(this.isOpenLoading) {
               this.closeLoading();
               this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: this.action_type + ' block time failed',
                  acceptText: 'OK'
               })
            }
         }, 10000);
      },
      closeLoading() {
         this.$vs.loading.close('#app > .con-vs-loading');
         this.isOpenLoading = false;
      },
   }
}
</script>

<style lang="scss">
.tip-setting {
   input{
      text-align: center;
      border: none !important;
   }
   .vs-input--input:focus{
      border: none !important;
      -webkit-box-shadow: none;
      box-shadow: none;
   }
   .vs-input-primary .vs-input--input:focus{
      border: 0px !important;
   }
   input::-webkit-outer-spin-button,
   input::-webkit-inner-spin-button {
   -webkit-appearance: none;
   margin: 0;
   }
}
</style>